export enum SolanaBotType {
  HOLDERS = 'holders',
  SMART_LIQUIDITY = 'smart-liquidity',
  BUY_SELL = 'buy-sell',
  COUNTER_TRADE = 'counter-trade',
}

/**
 * 'unlinked' is a special value that represents a wallet that is not linked to any bot
 */
export type SolanaBotUnlinkedWallet = 'unlinked';

export const SolanaBotTypeIdMap: Record<number, SolanaBotType> = {
  [14]: SolanaBotType.HOLDERS, // distribution bot
  [12]: SolanaBotType.SMART_LIQUIDITY,
  [13]: SolanaBotType.BUY_SELL,
  [15]: SolanaBotType.COUNTER_TRADE,
};

export const SolanaBotTypeNameMap: Record<SolanaBotType, string> = {
  [SolanaBotType.HOLDERS]: 'Distribution Bot',
  [SolanaBotType.SMART_LIQUIDITY]: 'Smart Liquidity Bot',
  [SolanaBotType.BUY_SELL]: 'Buy-Sell Bot',
  [SolanaBotType.COUNTER_TRADE]: 'Counter Trade Bot',
};
